import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "antd/dist/antd.min.css";
import Router from "./router";

const App = () => (
  <BrowserRouter>
    <Router />
  </BrowserRouter>
);

const container = document.getElementById("root");

if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
